import { useEffect, useState } from 'react';

import { Button, ButtonSize, ButtonStyles, ButtonTypes, Checkbox, DatePicker, Modal, RadioButton, Theme } from "..";
import { DynamicObjectInterface } from '../../../sdk/type';
import { InputSize } from '../Form/Input/types/enums';
import { BulkActionModalProps } from './types/propTypes';
import styles from './BulkActionModal.module.scss';

const BulkActionModal = ({
  labels,
  data,
  onModalClose,
  onConfirm,
  onCancel,
  config,
  note,
}: BulkActionModalProps) => {
  const { modalTitle, confirm, cancel } = labels;

  const [displayData, setDisplayData] = useState<DynamicObjectInterface>({});

  useEffect(() => {
    setDisplayData(data);
  }, []);

  const handleInputChange = (name: string, value: DynamicObjectInterface) => {
    setDisplayData((prev: DynamicObjectInterface) => ({
      ...prev,
      [name]: value
    }))
  }

  return (
    <Modal
      headline={modalTitle}
      primaryButtonLabel={confirm}
      primaryButton={
        <Button
          title={confirm}
          type={ButtonTypes.BUTTON}
          onClick={() => onConfirm(displayData)}
          buttonStyle={ButtonStyles.SOLID}
          size={ButtonSize.SMALL}
        />
      }
      secondaryButton={
        <Button
          title={cancel}
          type={ButtonTypes.BUTTON}
          onClick={() => onCancel()}
          buttonStyle={ButtonStyles.OUTLINE}
          size={ButtonSize.SMALL}
        />
      }
      closeIcon={false}
      onClose={onModalClose}
      containerWidth="425px"
    >
      <>
        <p className={styles['modal-remarks']}>{note}</p>
        <div className={styles['bulk-action-container']}>
          {config.map(({ name, label, type, options, optionsLayout = 'inline' }, index) => (
            <>
              <div key={name} className={styles['row-container']}>
                <div className={styles['checkbox-container']}>
                  <Checkbox
                    key={`${name}Checkbox`}
                    className={styles['checkbox']}
                    checked={!!displayData?.[name] || displayData?.[name] === 0}
                    onChange={() => handleInputChange(name, '')}
                    theme={Theme.GRAY}
                    text=""
                  />
                </div>
                <div className={styles['input-container']}>
                  <div className={styles['label-text']}>{label}</div>

                  {type === 'checkboxRadio' && options && (
                    <div className={styles[optionsLayout === 'inline' ? 'radio-button-container' : 'radio-button-container-block']}>
                      {options.map((option) => (
                        <div className={styles['radio-button-item']}>
                          <RadioButton
                            key={option.value}
                            label={option.label}
                            checked={displayData?.[name] === option.value}
                            onChange={() => handleInputChange(name, option.value)}
                          />
                        </div>
                      ))}
                    </div>
                  )}

                  {type === 'checkboxDate' && (
                    <DatePicker
                      inputContainerHeight="36px"
                      showDateContainer
                      value={displayData?.[name] ? new Date(displayData[name]) : undefined}
                      onChange={(date) =>
                        handleInputChange(name, date?.toISOString() ?? '')
                      }
                      inputSize={InputSize.SMALL}
                      contentHeight={'77vh'}
                      disabledFutureDates
                    />
                  )}
                </div>
              </div>

              {/* Render <hr> after each row except the last */}
              {index !== config.length - 1 && (
                <hr className={styles['horizontal-line']} />
              )}
            </>
          ))}
        </div>
      </>
    </Modal>
  )
}

export default BulkActionModal;